<template>
  <div
    class="player"
    v-bind:class="{
      'player--current': player.active
    }"
  >
    <div class="player__name">{{ player.name }}</div>
    <div class="player__inner">
      <div class="player__hand">
        <Card
          v-for="card in player.inHand"
          v-bind:key="card.key"
          v-bind:active="player.active"
          v-bind:card="card"
          v-bind:from="'hand'"
        />
      </div>
      <div class="player__box">
        <CardPlaceHolder
          v-for="(putAway, index) in player.putAway"
          v-bind:key="index"
          v-bind:type="'putAway'"
          v-bind:position="index"
          v-bind:active="player.active"
          v-bind:cardLength="putAway.length"
        >
          <Card
            v-bind:card="putAway[putAway.length - 1]"
            v-bind:active="player.active"
            v-bind:from="'putAway'"
            v-bind:position="index"
          />
        </CardPlaceHolder>
        <CardPlaceHolder v-bind:cardLength="player.stock.length">
          <Card
            v-bind:card="player.stock[player.stock.length - 1]"
            v-bind:active="player.active"
            v-bind:from="'stock'"
          />
        </CardPlaceHolder>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue';
import CardPlaceHolder from './CardPlaceHolder.vue';
export default {
  props: {
    player: Object
  },
  components: {
    Card,
    CardPlaceHolder
  }
};
</script>

<style lang="scss" scoped>
.player {
  display: inline-flex;
  flex-direction: column;
  margin: 0 auto;

  &__name {
    font-family: 'Source Sans Pro', sans-serif;
    color: #150b0b;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 10px;
  }

  &__inner {
    display: flex;
  }

  &__hand {
    position: relative;
    display: inline-flex;
    margin-right: -5px;
    margin-left: 40px;
    width: 135px;

    .card {
      position: absolute;
      top: 0;
      z-index: 1;
      transition: zIndex ease-in-out 1s;

      &:nth-child(1) {
        left: -40px;
      }

      &:nth-child(2) {
        left: -20px;
      }

      &:nth-child(4) {
        left: 20px;
      }

      &:nth-child(5) {
        left: 40px;
      }
    }
  }

  &__box {
    display: inline-flex;
    margin: 0 -15px;
  }

  &--current & {
    &__hand {
      .card {
        &:hover {
          z-index: 2;
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>
